import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import type { DealTabs } from '@makemydeal/dr-shared-types';

import { useSecurityDepositField } from './hooks/useSecurityDepositField';

const SecurityDepositField = ({ tab }: { tab?: DealTabs }) => {
    const { label, inputProps } = useSecurityDepositField({ tab });

    return <NumericInput label={label} {...inputProps} />;
};

export default SecurityDepositField;
